import React, { useEffect, useState } from 'react'

import { Box, Button, TextField } from '@mui/material'
import { DETAILS_PANELS } from 'features/customers/constants/detailsPanels'
import { useCustomerAIContext } from 'features/customers/hooks/useCustomerAIContext'
import { useCustomerAIContextActions } from 'features/customers/hooks/useCustomerAIContextActions'

import { SectionPanel } from 'components/_base'

type CustomerAIContextProps = {
  customer?: Record<string, any>
}

const CustomerAIContext = ({ customer }: CustomerAIContextProps) => {
  const aiContext: any = useCustomerAIContext(customer?.id)
  const [context, setContext] = useState(aiContext.data?.context || '')
  const [open, setOpen] = useState(true)
  const actions = useCustomerAIContextActions(customer?.id)

  useEffect(() => {
    if (!aiContext.isLoading) setContext(aiContext.data?.context || '')
  }, [aiContext.isLoading])

  const handleChange = (env: any) => {
    setContext(env.target.value)
  }

  const handleSave = async () => actions.upsert({ context })

  const handleDelete = async () => {
    await actions.del()
    setContext('')
  }

  return (
    <SectionPanel
      color={DETAILS_PANELS.ai.color}
      icon={DETAILS_PANELS.ai.icon}
      onToggle={() => setOpen(current => !current)}
      open={open}
      title={DETAILS_PANELS.ai.title}>
      <Box sx={{ px: 2, py: 1.5 }}>
        <TextField
          error={aiContext.error}
          fullWidth
          multiline
          onChange={handleChange}
          placeholder="Enter AI Context"
          value={context}
        />
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: '1rem', gap: '1.4rem' }}>
          <Button
            color="primary"
            disabled={aiContext.isLoading || actions.isLoading || aiContext.error || context.length === 0}
            onClick={handleSave}
            variant="contained">
            Save
          </Button>
          <Button
            color="secondary"
            disabled={aiContext.isLoading || actions.isLoading || aiContext.error}
            onClick={handleDelete}
            variant="contained">
            Delete
          </Button>
        </Box>
      </Box>
    </SectionPanel>
  )
}

export default CustomerAIContext
